import React from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

/**
 * 
 * @returns 
 */
const CoreFeatures = () => {

    let publicUrl = process.env.PUBLIC_URL + '/'

    return (
        <div className="ltn__feature-area pt-60 pb-0 go-top">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title-area ltn__section-title-2--- text-center">
                            <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">Caractéristiques</h6>
                            <h1 className="section-title">Caractéristiques principales</h1>
                        </div>
                    </div>
                </div>
                <div className="row ltn__custom-gutter">
                    <div className="col-lg-3 col-sm-6 col-12">
                        <div className="ltn__feature-item ltn__feature-item-6">
                            <div className="ltn__feature-icon">
                                <span><i className="flaticon-apartment" /></span>
                            </div>
                            <div className="ltn__feature-info">
                                <h4><Link to="/service-details">Biens immobilères de qualité</Link></h4>
                                <p>Des biens qui allient qualité, confort et potentiel, pour répondre à vos attentes les plus exigeantes.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                        <div className="ltn__feature-item ltn__feature-item-6 active">
                            <div className="ltn__feature-icon">
                                <span><i className="flaticon-park" /></span>
                            </div>
                            <div className="ltn__feature-info">
                                <h4><Link to="/service-details">Construction ECO</Link></h4>
                                <p>Des projets immobiliers éco-responsables, alliant innovation et respect de la planète, pour un avenir durable.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                        <div className="ltn__feature-item ltn__feature-item-6">
                            <div className="ltn__feature-icon">
                                <span><i className="flaticon-maps-and-location" /></span>
                            </div>
                            <div className="ltn__feature-info">
                                <h4><Link to="/service-details">Emplacement attrayant</Link></h4>
                                <p>Des propriétés bien situées, dans des quartiers recherchés, proches des commodités, pour un cadre de vie idéal.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                        <div className="ltn__feature-item ltn__feature-item-6">
                            <div className="ltn__feature-icon">
                                <span><i className="flaticon-excavator" /></span>
                            </div>
                            <div className="ltn__feature-info">
                                <h4><Link to="/service-details">Technologie moderne</Link></h4>
                                <p>Des technologies modernes au cœur de nos projets, pour des propriétés plus sûres et plus adaptées à vos besoins.</p>
                                {/* <p>Des technologies modernes au cœur de nos projets, des constructions high-tech, alliant domotique, énergies renouvelables et matériaux innovants, pour un cadre de vie intelligent.</p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoreFeatures;